import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './paginator.magic.css.js';
import script from './paginator.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"paginator",attrs:{"part":"paginator"}},[_c('ul',{staticClass:"pages",attrs:{"part":"pages"}},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,staticClass:"page",attrs:{"part":"page"}},[_c('magic-router-link',{staticClass:"link",class:{
                    'is-inactive': !link.isEnabled,
                    'link--current': link.isCurrent,
                },attrs:{"part":_vm.$p('link', {
                    'is-inactive': !link.isEnabled,
                    'link--current': link.isCurrent,
                }),"to":link.link},on:{"click":function($event){return _vm.setPage(link.page, $event)}}},[(link.icon)?_c('magic-ui-icon',{staticClass:"icon",attrs:{"part":"icon","name":link.icon}}):(link.page)?_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":link.page}}):_vm._e()],1)],1)}),0)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3bca4329_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-3bca4329";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
